<app-data-list
    [data]="data"
    [loading]="loadingData"
    [columns]="columns"
    [rowCls]="rowCls"
    [rowUrl]="'/admin/quotations/'"
    [orderBy]="orderBy"
    (updatedOrderBy)="updatedOrderBy($event)"
    (prevPage)="prevPage()"
    (nextPage)="nextPage()"
    [currentPage]="currentPage"
    [rightBtns]="
        hasAclAccess(EnumAcl.quotationsAdd)
            ? [
                  {
                      label: 'GENERAL.ADD',
                      icon: faPlus,
                      url: '/admin/quotations/add/' + enquiryId
                  }
              ]
            : []
    "
></app-data-list>
